// @ts-nocheck

import { initialState } from './reducer';

const optionsSelector = (state) => state['multiSelectDropdown'] || initialState;

export const getMultiSelectOptions = (state, componentId) => {
	return optionsSelector(state)?.[componentId] ?? { hasMore: false };
};
